<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "community",
};
</script>

<style lang="scss">
@import "../../static/style/common.scss";
@import "../../static/style/mixin.scss";
@import "../../static/style/font_icon/iconfont.css";
</style>



// WEBPACK FOOTER //
// entries/community/community.vue